import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Form for rule_type='tier_based'.
 * rule_value shape: { per_tier: { 1: a, 2: b, ..., 10: j } }
 * 10 inputs (T1..T10).
 */
const TIERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const TierBasedRuleForm = ({ value, onChange, disabled }) => {
  const { t } = useTranslation();
  const perTier = value?.per_tier ?? {};

  const handleTier = (tier, raw) => {
    const next = { ...perTier };
    if (raw === '' || raw === null) {
      delete next[tier];
    } else {
      next[tier] = Number(raw);
    }
    onChange({ per_tier: next });
  };

  return (
    <div className="space-y-2">
      <label className="block text-xs uppercase tracking-widest text-muted-foreground font-semibold">
        {t('admin.objectiveRules.form.tierBased.title', 'Per-tier values (T1 → T10)')}
      </label>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
        {TIERS.map((tier) => (
          <div key={tier} className="flex flex-col gap-1">
            <label className="text-[10px] uppercase tracking-widest text-muted-foreground font-semibold">
              T{tier}
            </label>
            <input
              type="number"
              step="any"
              disabled={disabled}
              value={perTier[tier] ?? perTier[String(tier)] ?? ''}
              onChange={(e) => handleTier(tier, e.target.value)}
              className="w-full px-2 py-1.5 rounded-md bg-card border border-border text-foreground text-base tabular-nums outline-none focus:border-accent focus:ring-1 focus:ring-accent/30 disabled:opacity-60"
              placeholder="0"
            />
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">
        {t(
          'admin.objectiveRules.form.tierBased.help',
          "One numerical value per tier. Leave blank for tiers that don't apply."
        )}
      </p>
    </div>
  );
};

export default TierBasedRuleForm;
